/**
 * Success toast for resendUserInvitation. The email leaving is invisible on
 * screen, so the button and the action-menu item both say it went.
 */
export const INVITATION_RESENT_TITLE = "Invitation resent"
